<template>
  <div class="home">
    <HeaderBar :title="title" :leftArrow="true"></HeaderBar>
    <div class="center-box">
      <van-form @submit="onSubmit">
        <DesignFormItem v-for="(item,index) in formRowList" :key="index" v-model="form[item.model]" :dModel="item"
          :options="item.options" v-show="showFormItem(item)"></DesignFormItem>
        <FormNormalUpload label="相关资料" ref="normalUpload" :infoGuid="form.guid" v-if="templateModel.config.needFile"></FormNormalUpload>
      </van-form>
      <div class="form-button-box">
        <van-row gutter="20">
          <van-col :span="templateModel.config.needCheck?12:24">
            <van-button block class="button-grey color-blue" @click="SaveInfo(0)">保存</van-button>
          </van-col>
          <van-col span="12" v-if="templateModel.config.needCheck">
            <van-button block class="button-grey  color-green" @click="SaveInfo(1)">提交</van-button>
          </van-col>
        </van-row>
      </div>
    </div>
    <FooterBar></FooterBar>
  </div>
</template>

<script>
  import designConfig from '../designConfig.js'
  export default {
    name: 'sDemoSampleForm',
    data() {
      return {
        title: "修改",
        // 模板JSON转化数据
        templateModel: {
          config: {
            needFile: false,
            needCheck: false,
            checkGuid: "",
          }
        },
        // 表单对象
        form: {
          guid: "",
        },
        // 地址栏query参数
        queryModel: {},
        // 表单行对象
        formRowList: [],
        // 获得模板对象地址
        templateUrl: designConfig.baseUrl + "/form/template/queryByCode/",
        // 详情信息
        infoUrl: designConfig.baseUrl + "/form/data/",
        // 保存信息
        saveUrl: designConfig.baseUrl + "/form/data/",
      }

    },
    watch: {
      form: {
        deep: true,
        handler: function() {
          console.log("变化了");
        }
      }
    },
    components: {

    },
    methods: {
      // 获得模板对象
      getSampleData() {
        let that = this
        // 后面根据地址栏带的表单编码，请求后台
        that.$utils.HttpGet(this.templateUrl + '?code=' + that.pageCode,
          function(data) {
            // 将模板数据转为JSON对象
            let sampleData = JSON.parse(data.data.templateData)

            sampleData.allList = that.$designUtils.setFormRules(sampleData)

            that.formTemplate = data.data
            that.templateModel = sampleData

            // 将query里的参数传入form对象里
            that.$designUtils.setQueryValue(that.queryModel, that.form, sampleData)
            //  将options里的默认值赋予给form对象
            that.$designUtils.setFormDefaultValue(that.form, sampleData)

            // 设置行对象
            that.formRowList = that.$utils.clone(sampleData.allList);

            that.$nextTick(function() {
              that.LoadInfo()
            })

          })
      },
      // 加载信息
      LoadInfo: function() {
        let that = this
        // 没有guid,新增模式
        if (!that.$route.params.hasOwnProperty("guid") && !that.serviceGuid) {
          that.saveUrl += 'save'
          return;
        }

        //有guid,修改模式
        that.saveUrl += 'update'
        // that.form.guid = that.$route.params.guid
        let requestId = that.serviceGuid ? that.serviceGuid : that.$route.params.guid
        let url = that.infoUrl + `${that.pageCode}/${requestId}`
        that.$utils.HttpGet(url, function(data) {
          let dataModel = data.data
          // 后台要求，删除id和addTime属性
          delete dataModel.id
          delete dataModel.addTime
          that.form = that.$designUtils.setFormInfoDate(that.templateModel, dataModel)
          // that.form = dataModel
        })
      },
      // 保存信息
      SaveInfo: function(saveType) {
        let that = this

        //提交状态需要confirm提醒
        if (saveType == 1) {
          that.$dialog.confirm({
            title: '提示',
            message: '提交后无法修改，确认提交吗',
          }).then(() => {
            that.FormSubmit(saveType)
          }).catch(() => {

          })
        } else {
          that.FormSubmit(saveType)
        }

      },
      //提交表单事件
      FormSubmit: function(saveType) {
        let that = this
        let configModel = that.templateModel.config
        // 提交的 data数据
        let paramsData = {
          formData: that.form,
          formCode: that.pageCode
        }

        // 提交的文件数据
        let fileList = []

        // 需要上传文件，则重新获取数据
        if (configModel.needFile) {
          fileList = that.$refs.normalUpload.GetFileList()
        }


        // 提交的审核数据
        let paramsAudit = {}

        // 审核模式,填充审核相关数据
        if (configModel.needCheck) {
          paramsAudit = {
            saveType: saveType,
            filePath: that.$options.name,
            workFlowId: configModel.workFlowId,
            workName: configModel.workName,
            businessId: configModel.businessId,
            query: JSON.stringify(that.queryModel)
          }

        }
        // 设置提交对象
        let params = {
          data: paramsData,
          fileList: fileList,
          audit: paramsAudit
        }
        // 保存信息调用方法
        let saveMethod = "HttpPost"
        // 修改模式，保存方式改为HttpPut
        if (that.form.guid) {
          saveMethod = "HttpPut"
        }

        that.$utils[saveMethod](that.saveUrl, params, function() {
          that.$dialog({
            message: '保存成功',
          })
          that.Back()
        })
      },
      onSubmit() {
        console.log(this.form);
      },
      // 根据配置的动态表达式,显示或隐藏表单元素
      showFormItem(itemModel) {
        let that = this

        let scriptModel = itemModel.options
        // 默认设置为可见
        itemModel.showItem = true
        // 判断传入对象是否含有dynamicVisible
        if (scriptModel.hasOwnProperty("dynamicVisible") && scriptModel.dynamicVisible) {
          // 获得动态表达式
          let script = scriptModel.dynamicVisibleValue
          // 调用动态执行脚本的方法,设置给对象
          itemModel.showItem = that.$utils.dynamicFun(script, that)
        }
        return itemModel.showItem
      },
    },
    mounted() {
      let that = this
      // 判断 serviceQuery 是否存在code属性，
      // 存在，表示是从审核页面传入,不存在，正常页面带参数跳转
      that.queryModel = that.serviceQuery.hasOwnProperty("code") ? that.serviceQuery : that.$route.query
      that.pageCode = that.queryModel.code
      if (that.pageCode) {
        that.getSampleData()
      }
      //判断是否存在serviceGuid,存在标识是从审核页嵌入了当前页面
      if (that.serviceGuid) {
        // that.queryMode = JSON.parse()
        that.getSampleData()
      }
    }
  }
</script>
<style scoped>

</style>
